export default __webpack_public_path__ + "static/media/filter-minus-icon.9dd988d2.svg";